<template>
  <div class="f-v f-ast">
    <donut-modal-sections-title :title="valuesForType[type].title" />
    <template v-if="type === 'create' || type === 'edit'">
      <input v-model="roleName" type="text" placeholder="Role name...">
    </template>
    <template v-if="type === 'archive'">
      <div class="t">Are you sure? Archiving this role will not affect existing sessions or messages.</div>
    </template>
    <template v-if="type === 'unarchive'">
      <div class="t">Do you want to activate this role?</div>
    </template>
    <donut-modal-sections-actions
      :button-text="valuesForType[type].buttonText || 'Save'"
      :is-save-disabled="isSaveDisabled"
      :loading-on-save="true"
      @save="onSave"
    />
  </div>
</template>

<script setup>
  import Network from 'lib/api/network';
  import { ref, computed } from 'vue';
  import { useStore } from 'vuex';

  const { state, commit, dispatch } = useStore();

  const role = computed(() => state.modal.data.role);
  const type = computed(() => state.modal.data.editType);

  // Name Editing
  const roleName = ref(role.value?.name || '');
  const isSaveDisabled = computed(() => roleName.value.trim().length === 0);

  // Type-Based Values
  const valuesForType = computed(() => ({
      create: {
        title: 'Create Role',
        saveArgs: { name: roleName.value.trim() },
        toast: 'Successfully created role!',
        onSave: state.modal.data.onCreate,
      },
      edit: {
        title: `Rename ${role.value?.name}`,
        saveArgs: { name: roleName.value.trim() },
        toast: 'Successfully renamed role!',
        onSave: state.modal.data.onEdit,
      },
      archive: {
        title: `Archive ${role.value?.name}`,
        buttonText: 'Archive',
        saveArgs: { active: false },
        toast: 'Successfully archived role!',
        onSave: state.modal.data.onArchive,
      },
      unarchive: {
        title: `Activate ${role.value?.name}`,
        buttonText: 'Activate',
        saveArgs: { active: true },
        toast: 'Successfully activated role!',
        onSave: state.modal.data.onUnarchive,
      },
    }));

  const onSave = () => {
    commit('update', { key: 'formSubmitted', value: true });
    const args = { onboarding_role: valuesForType.value[type.value].saveArgs };
    const callbacks = {
      success: (data) => {
        dispatch('setSuccessToast', valuesForType.value[type.value].toast);
        valuesForType.value[type.value].onSave(data);
      },
      error: () => {
        dispatch('setErrorToast');
      },
      complete: () => {
        commit('update', { key: 'formSubmitted', value: false });
        commit('closeModal');
      },
    };
    if (type.value === 'create') {
      Network.post('/onboarding/roles', args, callbacks);
    } else {
      Network.put(`/onboarding/roles/${role.value.id}`, args, callbacks);
    }
  };
</script>
